module.exports = __webpack_public_path__ + "static/img/startnow.519b11e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/startnow.png
// module id = 7zfx
// module chunks = 1